import {
  GET_PACKAGING_FAILURE,
  GET_PACKAGING_REQUEST,
  GET_PACKAGING_SUCCESS,
} from "./packagingTypes";

const initialState = {
  loading: false,
  package: [],
  error: "",
};

const getPackagingReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PACKAGING_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_PACKAGING_SUCCESS:
      return {
        loading: false,
        package: action.payload,
        error: "",
      };
    case GET_PACKAGING_FAILURE:
      return {
        loading: false,
        package: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

// const initialStateWithPagination = {
//   loading: false,
//   documentType: [],
//   error: "",
// };

// const getDocumentTypeWithPaginationReducer = (
//   state = initialStateWithPagination,
//   action
// ) => {
//   switch (action.type) {
//     case GET_DOCUMENT_TYPE_WITH_PAGINATION_REQUEST:
//       return {
//         ...state,
//         loading: true,
//       };
//     case GET_DOCUMENT_TYPE_WITH_PAGINATION_SUCCESS:
//       return {
//         loading: false,
//         documentType: action.payload,
//         error: "",
//       };
//     case GET_DOCUMENT_TYPE_WITH_PAGINATION_FAILURE:
//       return {
//         loading: false,
//         documentType: [],
//         error: action.payload,
//       };
//     default:
//       return state;
//   }
// };

export {
  getPackagingReducer,
  //  getDocumentTypeWithPaginationReducer
};
